import { cn } from "@gettactic/helpers";
import { ScrollArea } from "@cmp-src/primitives/scroll-area";
import React from "react";
import {
  SearchInput,
  SearchProps
} from "@cmp-src/controls/SearchInput/SearchInput";

export interface SearchableListProps
  extends React.PropsWithChildren<Record<never, never>> {
  title?: string;
  teamSearchQuery: string;
  setSearchQuery: SearchProps["setQuery"];
  actionElement: React.ReactNode;
  scrollAreaClassName?: string;
  className?: string;
}
export const SearchableList = ({
  title,
  teamSearchQuery,
  setSearchQuery,
  actionElement,
  children,
  scrollAreaClassName,
  className
}: SearchableListProps) => (
  <div
    className={cn(
      "pt-6 flex flex-1 flex-col flex-nowrap items-stretch gap-3 overflow-hidden px-1",
      className
    )}
  >
    {title ? (
      <h3 className="py-1 text-lg font-bold text-secondary-foreground">
        {title}
      </h3>
    ) : null}
    <div className="flex items-center justify-between gap-4 sm:gap-16">
      <SearchInput query={teamSearchQuery} setQuery={setSearchQuery} />
      {actionElement}
    </div>
    <ScrollArea
      type="always"
      className={cn(
        "h-full rounded-lg border border-neutral-300",
        scrollAreaClassName
      )}
    >
      <ul className="divide-y divide-neutral-200">{children}</ul>
    </ScrollArea>
  </div>
);
